import { CellContext } from '@tanstack/react-table';
import { Device } from '@/types/device.types';
import { formatVehicleTypeForDisplay } from '@/config/deviceTypes.config';
import i18n from '@/i18n/i18n';

// TODO: Remove this once we have a proper type for the object
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceVehicleTypeCell = (info: CellContext<Device, any>) => {
  const type = info.row.original.vehicle.type;
  const currentLanguage = i18n.language === 'es' ? 'es' : 'en';

  return <span>{formatVehicleTypeForDisplay(type, currentLanguage as 'en' | 'es')}</span>;
};
